export default "__VITE_ASSET__DHEY6m5p__"